module.exports = __webpack_public_path__ + "static/img/8.8bb998f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/8.png
// module id = EyHv
// module chunks = 0